import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsTabsComponent } from './bs-tabs.component';
import { BsTabComponent } from './tab.component';

@NgModule({
  declarations: [BsTabsComponent, BsTabComponent],
  imports: [CommonModule],
  exports: [BsTabsComponent, BsTabComponent]
})
export class BsTabsModule {}
